.property-table {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  align-items: first baseline;
  line-height: var(--mantine-spacing-md);
  border-radius: var(--mantine-radius-sm);
  & &:has(.property) {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    background-color: alpha(var(--mantine-color-dark-5), 0.3);
  }
  & &:has(.property-table) {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    background: none;
    border: 1px solid var(--mantine-color-dark-5);
  }
}

.property {
  display: contents;
  /* &:has(.value:empty) { */
  /*   display: none; */
  /* } */
}

.key {
  align-items: first baseline;
  justify-self: end;
  font-size: var(--mantine-font-size-xs);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
  color: var(--mantine-color-dark-1);
  text-transform: uppercase;
}

.value {
  display: block;
}

.array-value {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-xs);
}

.null-value {
  font-style: italic;
  opacity: 0.7;
}

.string-value {
  max-height: 40cqh;
  overflow: auto;
  font-family: var(--mantine-font-family-monospace);
  font-size: var(--mantine-font-size-xs);
  white-space: pre-wrap;
}
